module.exports = __webpack_public_path__ + "static/media/step1_v2.fd0b6441.png";